import SectionLabel from '../../../../components/section-label/SectionLabel';
import SettingsContainer from '../../../../components/settings-container/SettingsContainer';
import { Subscription } from '../../../../types/firm';

type QuotaProps = {
    subscription: Subscription;
};

function Quota({ subscription }: QuotaProps): JSX.Element {
    return (
        <SettingsContainer>
            <SectionLabel
                title="Quota"
                description="View your current usage for quotas included in your subscription, such as procedure & checklist templates and workpapers per entity."
            />
            <div className="grid gap-y-8">
                <section className="grid gap-y-2 text-xs">
                    <p className="text-gray-600 dark:text-gray-400 font-medium">Procedures</p>
                    {subscription.quota.procedureLimit === null ? (
                        <span className="text-gray-800 dark:text-gray-200">Unlimited</span>
                    ) : (
                        <span className="text-gray-800 dark:text-gray-200">
                            {subscription.quota.procedureCount} / {subscription.quota.procedureLimit} remaining
                        </span>
                    )}
                </section>
                <section className="grid gap-y-2 text-xs">
                    <p className="text-gray-600 dark:text-gray-400 font-medium">Checklists</p>
                    {subscription.quota.checklistLimit === null ? (
                        <span className="text-gray-800 dark:text-gray-200">Unlimited</span>
                    ) : (
                        <span className="text-gray-800 dark:text-gray-200">
                            {subscription.quota.checklistCount} / {subscription.quota.checklistLimit} remaining
                        </span>
                    )}
                </section>
                <section className="grid gap-y-2 text-xs">
                    <p className="text-gray-600 dark:text-gray-400 font-medium">Workpapers per Entity</p>
                    {subscription.quota.workpaperPerEntityLimit === null ? (
                        <span className="text-gray-800 dark:text-gray-200">Unlimited</span>
                    ) : (
                        <span className="text-gray-800 dark:text-gray-200">{subscription.quota.workpaperPerEntityLimit}</span>
                    )}
                </section>
            </div>
        </SettingsContainer>
    );
}

export default Quota;
